import {createSelector} from 'reselect'
import {needMoreEntities} from './utils'

export default function(getEditorState) {
    const getEditingUserId = state => getEditorState(state).editingUserId

    const showEditor = createSelector(
        getEditingUserId,
        (userId) => userId !== null
    )

    const isLoaded = state => getEditorState(state).loaded

    const isLoading = state => getEditorState(state).loading

    const areCustomersLoaded = state => getEditorState(state).customersLoaded

    const areProjectsLoaded = state => getEditorState(state).projectsLoaded

    const areTasksLoaded = state => getEditorState(state).tasksLoaded

    const getEditingLevel = state => getEditorState(state).editingLevel

    const canManageParentCustomer = state => getEditorState(state).canManageParentCustomer

    const canManageParentProject = state => getEditorState(state).canManageParentProject

    const isCustomersLevelSelected = createSelector(
        getEditingLevel,
        level => !level.customerId && !level.projectId
    )

    const isProjectsLevelSelected = createSelector(
        getEditingLevel,
        level => !!level.customerId && !level.projectId
    )

    const isTasksLevelSelected = createSelector(
        getEditingLevel,
        level => !!level.customerId && !!level.projectId
    )

    const needMoreCustomers = createSelector(
        showEditor,
        isCustomersLevelSelected,
        isLoading,
        areCustomersLoaded,
        (show, levelSelected, loading, loaded) => needMoreEntities(show, levelSelected, loading, loaded)
    )

    const needMoreProjects = createSelector(
        showEditor,
        isProjectsLevelSelected,
        isLoading,
        areProjectsLoaded,
        (show, levelSelected, loading, loaded) => needMoreEntities(show, levelSelected, loading, loaded)
    )

    const needMoreTasks = createSelector(
        showEditor,
        isTasksLevelSelected,
        isLoading,
        areTasksLoaded,
        (show, levelSelected, loading, loaded) => needMoreEntities(show, levelSelected, loading, loaded)
    )

    const getCustomerIdsOrder = state => getEditorState(state).customerIdsOrder

    const getProjectIdsOrder = state => getEditorState(state).projectIdsOrder

    const getTaskIdsOrder = state => getEditorState(state).taskIdsOrder

    const areFutureCustomersAssigned = state => getEditorState(state).futureCustomersAssigned

    const areFutureProjectsAssigned = state => getEditorState(state).futureProjectsAssigned

    const areFutureTasksAssigned = state => getEditorState(state).futureTasksAssigned

    const getCanWorkCustomerIds = state => getEditorState(state).canWorkCustomerIds

    const getCanManageCustomerIds = state => getEditorState(state).canManageCustomerIds

    const getCanManageCustomerExcludeSelfIds = state => getEditorState(state).canManageCustomerExcludeSelfIds

    const getCanWorkProjectIds = state => getEditorState(state).canWorkProjectIds

    const getCanManageProjectIds = state => getEditorState(state).canManageProjectIds

    const getCanManageProjectExcludeSelfIds = state => getEditorState(state).canManageProjectExcludeSelfIds

    const getCanWorkTaskIds = state => getEditorState(state).canWorkTaskIds

    const getCanManageTaskIds = state => getEditorState(state).canManageTaskIds

    const getProjectCountsByCustomers = state => getEditorState(state).projectCountsByCustomers

    const getTaskCountsByCustomers = state => getEditorState(state).taskCountsByCustomers

    const getTaskCountsByProjects = state => getEditorState(state).taskCountsByProjects

    const areSomeCustomersOrLowerAssigned = state => getEditorState(state).someCustomersOrLowerAssigned

    const areAllCustomersAssigned = state => getEditorState(state).allCustomersAssigned

    const areSomeProjectsOrLowerAssigned = state => getEditorState(state).someProjectsOrLowerAssigned

    const areAllProjectsAssigned = state => getEditorState(state).allProjectsAssigned

    const areSomeTasksAssigned = state => getEditorState(state).someTasksAssigned

    const areAllTasksAssigned = state => getEditorState(state).allTasksAssigned

    const getChangingCustomerAssignments = state => getEditorState(state).changingCustomerAssignments

    const getChangingProjectAssignments = state => getEditorState(state).changingProjectAssignments

    const getChangingTaskAssignments = state => getEditorState(state).changingTaskAssignments

    const isChangingAllAssignments = state => getEditorState(state).changingAllAssignments

    const getCustomersSearchOpen = state => getEditorState(state).customersSearchOpen

    const getCustomersSearchText = state => getEditorState(state).customersSearchText

    const getProjectsSearchOpen = state => getEditorState(state).projectsSearchOpen

    const getProjectsSearchText = state => getEditorState(state).projectsSearchText

    const getTasksSearchOpen = state => getEditorState(state).tasksSearchOpen

    const getTasksSearchText = state => getEditorState(state).tasksSearchText

    const getViewerCanManageCustomerIds = state => getEditorState(state).viewerCanManageCustomerIds

    const getViewerCanManageProjectIds = state => getEditorState(state).viewerCanManageProjectIds

    return {
        getEditingUserId,
        showEditor,
        isLoaded,
        needMoreCustomers,
        needMoreProjects,
        needMoreTasks,
        isCustomersLevelSelected,
        isProjectsLevelSelected,
        isTasksLevelSelected,
        areCustomersLoaded,
        areProjectsLoaded,
        areTasksLoaded,
        getEditingLevel,
        getCustomerIdsOrder,
        getProjectIdsOrder,
        getTaskIdsOrder,
        areFutureCustomersAssigned,
        areFutureProjectsAssigned,
        areFutureTasksAssigned,
        getCanWorkCustomerIds,
        getCanManageCustomerIds,
        getCanManageCustomerExcludeSelfIds,
        getCanWorkProjectIds,
        getCanManageProjectIds,
        getCanManageProjectExcludeSelfIds,
        getCanWorkTaskIds,
        getCanManageTaskIds,
        getProjectCountsByCustomers,
        getTaskCountsByCustomers,
        getTaskCountsByProjects,
        areSomeCustomersOrLowerAssigned: areSomeCustomersOrLowerAssigned,
        areAllCustomersAssigned,
        areSomeProjectsOrLowerAssigned: areSomeProjectsOrLowerAssigned,
        areAllProjectsAssigned,
        areSomeTasksAssigned,
        areAllTasksAssigned,
        isLoading,
        getChangingCustomerAssignments,
        getChangingProjectAssignments,
        getChangingTaskAssignments,
        isChangingAllAssignments,
        getCustomersSearchOpen,
        getCustomersSearchText,
        getProjectsSearchOpen,
        getProjectsSearchText,
        getTasksSearchOpen,
        getTasksSearchText,
        getViewerCanManageCustomerIds,
        getViewerCanManageProjectIds,
        canManageParentCustomer,
        canManageParentProject,
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/hierarchyAssignmentsEditor/selectorsGenerator.js